let base = undefined;

export const installasjon = {
	// Finner første script-tag der src inneholder "apv-arbeidsvarsling"
	// DETTE _MÅ_ VÆRE SCRIPTET SOM KJØRES, ELLERS VIRKER IKKE TING
	getBase: function () {
		if (!base) {
			const scriptTag = document.querySelector(
				'script[src*=apv-arbeidsvarsling]'
			);
			const url = (scriptTag || { src: '' }).src;
			base = url.substring(0, url.lastIndexOf('/') + 1);
		}
		return base;
	},
	erDinSide: function () {
		return /https?\:\/\/(?:www\.)?(?:utv\.|test\.)?vegvesen\.no\/dinside(?:\/.*)?/i.test(
			window.location
		);
	},
	getMiljo: function () {
		let miljo = /$https?\:\/\/(?:[\w\.]+\.)?(?:\.(utv|test))?(?:\.atlas)?\.vegvesen\.no\/?/.exec(
			window.location
		);
		miljo = (miljo ? miljo[1] : 'utv') || 'prod';
		return miljo;
	},
};
